import { Icon } from "web/components"

function getIconForAction(action) {
  if (action.startsWith("created")) return "inbox-arrow-down"
  if (action.startsWith("added")) return "plus-circle"
  if (action.startsWith("deleted")) return "minus-circle"
  return "arrows-right-left"
}

export default function GenericEvent({ event }) {
  return (
    <>
      <Icon
        name={getIconForAction(event.action)}
        outline="true"
        width="20px"
        height="20px"
      />{" "}
      <span>{event.creator}</span>
      <span dangerouslySetInnerHTML={{ __html: event.action }}></span>
    </>
  )
}
